import { service } from '../../service';

const state = {
  podcast: null,
  podcastFound: true,
};

const getters = {
  getPodcast(state) {
    return state.podcast;
  },
  getPodcastFound(state) {
    return state.podcastFound;
  },
};

const actions = {
  async getPreviewLinkByToken({ commit }, id) {
    const { data } = await service.getPreviewLinkByToken(id);
    if (data.link) commit('SET_PODCAST_FOUND', true);
    else commit('SET_PODCAST_FOUND', false);
    commit('SET_PODCAST_MEDIA', data);
  },
};

const mutations = {
  SET_PODCAST_MEDIA(state, podcast) {
    state.podcast = podcast;
  },
  SET_PODCAST_FOUND(state, podcastFound) {
    state.podcastFound = podcastFound;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/podcast.js